import {
    Alert,
    Box,
    Button,
    IconButton,
    Slide,
    Stack,
    SxProps,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { SettingsState, Store } from '../store/types';
import { useTranslation } from '../contexts/TranslationContext';
import { CloseOutlined, ReloadOutlined } from '@ant-design/icons';
import { setNetworkError } from '../store/reducers/settings';

type NetworkConnectionAlertProps = {
    bottom?: boolean;
};

export default function NetworkConnectionAlert({
    bottom,
}: NetworkConnectionAlertProps) {
    const dispatch = useDispatch();
    const { loadTranslations, translate } = useTranslation();
    const { networkError, networkErrorHidden } = useSelector<
        Store,
        SettingsState
    >(state => state.settings);

    const close = () => {
        dispatch(setNetworkError({ error: true, hidden: true }));
    };

    const open = networkError && !networkErrorHidden;

    let containerSx: SxProps = {
        height: 68,
        position: open ? 'sticky' : 'absolute',
        top: 60,
    };
    if (bottom) {
        containerSx = {
            position: 'absolute',
            overflow: 'hidden',
            width: '100%',
            bottom: 0,
        };
    }

    const retryAction = (
        <Stack direction="row" alignItems="center">
            <Button
                color="inherit"
                size="small"
                sx={{ textTransform: 'none' }}
                startIcon={<ReloadOutlined size={14} />}
                onClick={() => loadTranslations()}>
                {translate('errors.retry')}
            </Button>
            <IconButton color="inherit" onClick={close}>
                <CloseOutlined size={14} />
            </IconButton>
        </Stack>
    );

    return (
        <Box sx={containerSx}>
            <Slide in={open} unmountOnExit direction={bottom ? 'up' : 'down'}>
                <Alert
                    variant="filled"
                    severity="warning"
                    sx={{ borderRadius: 0 }}
                    action={retryAction}>
                    {translate('errors.no_connection')}
                </Alert>
            </Slide>
        </Box>
    );
}
